import { createRouter, createWebHistory, type RouteLocationNormalized } from 'vue-router'

//employee
const EmployeeDetails = () => import('@/pages/employee/EmployeeDetails.vue')
//issue
const AssignIssue = () => import('@/pages/issue/AssignIssue.vue')
const CreateIssueFinancialAction = () => import('@/pages/issue/CreateIssueFinancialAction.vue')
//ride
const ViewRideMap = () => import('@/pages/ride/ViewRideMap.vue')
const CreateRideIssue = () => import('@/pages/ride/CreateRideIssue.vue')
const CancelRide = () => import('@/pages/ride/CancelRide.vue')
const EndRide = () => import('@/pages/ride/EndRide.vue')
//campaign
const CreateCampaign = () => import('@/pages/campaign/CreateCampaign.vue')
const UpdateCampaign = () => import('@/pages/campaign/UpdateCampaign.vue')
const UpdateCampaignAttachments = () => import('@/pages/campaign/UpdateCampaignAttachments.vue')
const ActivateCampaign = () => import('@/pages/campaign/ActivateCampaign.vue')
const DeactivateCampaign = () => import('@/pages/campaign/DeactivateCampaign.vue')
//voucher
const CreateNewVoucherBatch = () => import('@/pages/voucher/CreateNewVoucherBatch.vue')
const UpdateVoucherBatch = () => import('@/pages/voucher/UpdateVoucherBatch.vue')
//user
const BlockUser = () => import('@/pages/user/BlockUser.vue')
const ReleaseUserBlock = () => import('@/pages/user/ReleaseUserBlock.vue')
const WarnUser = () => import('@/pages/user/WarnUser.vue')
const ActivateUser = () => import('@/pages/user/ActivateUser.vue')
const DeactivateUser = () => import('@/pages/user/DeactivateUser.vue')
const CreateGeneralIssue = () => import('@/pages/user/CreateGeneralIssue.vue')
const DeleteUser = () => import('@/pages/user/DeleteUser.vue')
const AllowDriverChangePhone = () => import('@/pages/user/AllowDriverChangePhone.vue')
const PreventDriverChangePhone = () => import('@/pages/user/PreventDriverChangePhone.vue')
const CheckDriverWaslInfo = () => import('@/pages/user/CheckDriverWaslInfo.vue')
const RegisterDriverInWasl = () => import('@/pages/user/RegisterDriverInWasl.vue')
const ViewDriverAttachments = () => import('@/pages/user/ViewDriverAttachments.vue')
const UpdateDriver = () => import('@/pages/user/UpdateDriver.vue')
const UpdateDriverVehicle = () => import('@/pages/user/UpdateDriverVehicle.vue')
//registration
const RegistrationRequestLayout = () =>
  import('@/layouts/user/registration/RegistrationRequestLayout.vue')
const RegistrationRequestVehicleInfo = () =>
  import('@/pages/user/registration/RegistrationRequestVehicleInfo.vue')
const RegistrationRequestPersonalInfo = () =>
  import('@/pages/user/registration/RegistrationRequestPersonalInfo.vue')
const ApproveRegistrationRequest = () =>
  import('@/pages/user/registration/ApproveRegistrationRequest.vue')
const RejectRegistrationRequest = () =>
  import('@/pages/user/registration/RejectRegistrationRequest.vue')

//general
const Login = () => import('@/pages/LoginPage.vue')
const NotFound = () => import('@/pages/NotFound.vue')
const Home = () => import('@/pages/HomePage.vue')
const SearchResults = () => import('@/pages/SearchResults.vue')

const userRoutes = (role: 'client' | 'driver') => [
  {
    path: `/${role}s/:userId/block`,
    name: `block-${role}`,
    component: BlockUser,
    props: (route: RouteLocationNormalized) => ({
      userRole: role,
      userId: route.params.userId,
      issueId: route.query.issueId
    })
  },
  {
    path: `/${role}s/:userId/release-block`,
    name: `release-${role}-block`,
    component: ReleaseUserBlock,
    props: (route: RouteLocationNormalized) => ({
      userRole: role,
      userId: route.params.userId,
      issueId: route.query.issueId
    })
  },
  {
    path: `/${role}s/:userId/warn`,
    name: `warn-${role}`,
    component: WarnUser,
    props: (route: RouteLocationNormalized) => ({
      userRole: role,
      userId: route.params.userId,
      issueId: route.query.issueId
    })
  },
  {
    path: `/${role}s/:userId/delete`,
    name: `delete-${role}`,
    component: DeleteUser,
    props: (route: RouteLocationNormalized) => ({
      userRole: role,
      userId: route.params.userId
    })
  },
  {
    path: `/${role}s/:userId/activate`,
    name: `activate-${role}`,
    component: ActivateUser,
    props: (route: RouteLocationNormalized) => ({
      userRole: role,
      userId: route.params.userId
    })
  },
  {
    path: `/${role}s/:userId/deactivate`,
    name: `deactivate-${role}`,
    component: DeactivateUser,
    props: (route: RouteLocationNormalized) => ({
      userRole: role,
      userId: route.params.userId
    })
  },
  {
    path: `/${role}s/:userId/create-general-issue`,
    name: `create-${role}-general-issue`,
    component: CreateGeneralIssue,
    props: (route: RouteLocationNormalized) => ({
      userRole: role,
      userId: route.params.userId
    })
  }
]
const driverRoutes = [
  {
    path: '/drivers/:driverId/allow-change-phone',
    name: 'allow-driver-change-phone',
    component: AllowDriverChangePhone,
    props: (route: RouteLocationNormalized) => ({
      driverId: route.params.driverId
    })
  },
  {
    path: '/drivers/:driverId/prevent-change-phone',
    name: 'prevent-driver-change-phone',
    component: PreventDriverChangePhone,
    props: (route: RouteLocationNormalized) => ({
      driverId: route.params.driverId
    })
  },
  {
    path: '/drivers/:driverId/check-wasl-info',
    name: 'check-driver-wasl-info',
    component: CheckDriverWaslInfo,
    props: (route: RouteLocationNormalized) => ({
      driverId: route.params.driverId
    })
  },
  {
    path: '/drivers/:driverId/register-in-wasl',
    name: 'register-driver-in-wasl',
    component: RegisterDriverInWasl,
    props: (route: RouteLocationNormalized) => ({
      driverId: route.params.driverId
    })
  },
  {
    path: '/drivers/:driverId/update',
    name: 'update-driver',
    component: UpdateDriver,
    props: (route: RouteLocationNormalized) => ({
      driverId: route.params.driverId
    })
  },
  {
    path: '/drivers/:driverId/update-vehicle',
    name: 'update-driver-vehicle',
    component: UpdateDriverVehicle,
    props: (route: RouteLocationNormalized) => ({
      driverId: route.params.driverId
    })
  },
  {
    path: '/drivers/:driverId/view-attachments',
    name: 'view-driver-attachments',
    component: ViewDriverAttachments,
    props: (route: RouteLocationNormalized) => ({
      driverId: route.params.driverId
    })
  }
]
const employeeRoutes = [
  {
    path: '/employees/new',
    name: 'CreateNewEmployee',
    component: EmployeeDetails,
    props: { employeeId: 'new' }
  },
  {
    path: '/employees/:employeeId',
    name: 'EmployeeDetails',
    component: EmployeeDetails,
    props: (route: RouteLocationNormalized) => ({ employeeId: route.params.employeeId })
  }
]

const issueRoutes = [
  {
    path: '/issues/:issueId/assign',
    name: 'assign-issue',
    component: AssignIssue,
    props: (route: RouteLocationNormalized) => ({ issueId: route.params.issueId })
  },
  {
    path: '/issues/:issueId/financial-action',
    name: 'create-issue-financial-action',
    component: CreateIssueFinancialAction,
    props: (route: RouteLocationNormalized) => ({ issueId: route.params.issueId })
  }
]

const rideRoutes = [
  {
    path: '/rides/:rideId/map',
    name: 'view-ride-map',
    component: ViewRideMap,
    props: (route: RouteLocationNormalized) => ({ rideId: route.params.rideId })
  },
  {
    path: '/rides/:rideId/create-ride-issue',
    name: 'create-ride-issue',
    component: CreateRideIssue,
    props: (route: RouteLocationNormalized) => ({ rideId: route.params.rideId })
  },
  {
    path: '/rides/:rideId/cancel',
    name: 'cancel-ride',
    component: CancelRide,
    props: (route: RouteLocationNormalized) => ({ rideId: route.params.rideId })
  },
  {
    path: '/rides/:rideId/end',
    name: 'end-ride',
    component: EndRide,
    props: (route: RouteLocationNormalized) => ({ rideId: route.params.rideId })
  }
]

const campaignRoutes = [
  {
    path: '/campaigns/create',
    name: 'create-campaign',
    component: CreateCampaign
  },
  {
    path: '/campaigns/:campaignId/update',
    name: 'update-campaign',
    component: UpdateCampaign,
    props: (route: RouteLocationNormalized) => ({
      campaignId: route.params.campaignId
    })
  },
  {
    path: '/campaigns/:campaignId/update-attachments',
    name: 'update-campaign-attachments',
    component: UpdateCampaignAttachments,
    props: (route: RouteLocationNormalized) => ({
      campaignId: route.params.campaignId
    })
  },
  {
    path: '/campaigns/:campaignId/activate',
    name: 'activate-campaign',
    component: ActivateCampaign,
    props: (route: RouteLocationNormalized) => ({
      campaignId: route.params.campaignId
    })
  },
  {
    path: '/campaigns/:campaignId/deactivate',
    name: 'deactivate-campaign',
    component: DeactivateCampaign,
    props: (route: RouteLocationNormalized) => ({
      campaignId: route.params.campaignId
    })
  }
]

const voucherRoutes = [
  {
    path: '/voucher-batch/new',
    name: 'CreateNewVoucherBatch',
    component: CreateNewVoucherBatch
  },
  {
    path: '/voucher-batch/:voucherBatchId',
    name: 'UpdateVoucherBatch',
    component: UpdateVoucherBatch,
    props: (route: RouteLocationNormalized) => ({
      voucherBatchId: route.params.voucherBatchId
    })
  }
]

const registrationRoutes = [
  {
    path: '/registration-requests/:driverId',
    name: 'RegistrationRequest',
    props: (route: RouteLocationNormalized) => ({ driverId: route.params.driverId }),
    component: RegistrationRequestLayout,
    children: [
      {
        path: 'personal-info',
        name: 'RegistrationRequestPersonalInfo',
        component: RegistrationRequestPersonalInfo
      },
      {
        path: 'vehicle-info',
        name: 'RegistrationRequestVehicleInfo',
        component: RegistrationRequestVehicleInfo
      }
    ]
  },
  {
    path: '/registration-requests/:driverId/approve',
    name: 'approve-registration-request',
    component: ApproveRegistrationRequest,
    props: (route: RouteLocationNormalized) => ({
      driverId: route.params.driverId
    })
  },
  {
    path: '/registration-requests/:driverId/reject',
    name: 'reject-registration-request',
    component: RejectRegistrationRequest,
    props: (route: RouteLocationNormalized) => ({
      driverId: route.params.driverId
    })
  }
]

const generalRoutes = [
  {
    path: '/search-results',
    name: 'SearchResults',
    component: SearchResults,
    props: (route: RouteLocationNormalized) => ({ term: route.query.term })
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFound }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior() {
    return { top: 0 }
  },
  routes: [
    ...employeeRoutes,
    ...issueRoutes,
    ...rideRoutes,
    ...campaignRoutes,
    ...voucherRoutes,
    ...registrationRoutes,
    ...driverRoutes,
    ...userRoutes('driver'),
    ...userRoutes('client'),
    ...generalRoutes
  ]
})

export default router
